export enum AuthPagesEnum {
  DEAFAULT = "/",
  ORDERS = "/orders",
  CLIENTS = "/clients",
  PRODUCTION = "/production",
  PRODUCT = "/product",
  WAREHOUSE = "/warehouse",
  RESOURCES = "/resources",
  SUPPLEIERS = "/suppliers",
  EMPLOYEES = "/employees",
  MANAGEMENT = "/management",
  TAGS = "/tags",
  PRODUCT_TYPES = "/product-types",
  CATEGORIES = "/categories",
  BRANDS = "/brands",
  DISCOUNTS = "/discounts",
  HISTORY = "/history",
  CRM_ORDERS = "/crmorders",
  PRODUCTS_ORDER = "/products-order",
  BLOGS = "/blogs",
}
